<div id="add-user" class="contenedor-add-user">
  <div id="add-user" class="user-container">
    <div class="container-breadcrumb">
      <p id="id-breadcrumb-user" class="copec-lg-14">
        Usuarios / <span class="ruta">Crear Nuevo Usuario/</span>
      </p>
    </div>
    <div id="1" class="container-button-subtitle">
      <div class="box-button1">
        <span class="copec-bold-30">Crear nuevo usuario</span>
      </div>
    </div>
    <div class="espacio"></div>
  </div>
  <mat-accordion>
    <mat-expansion-panel [expanded]="step === 0">
      <mat-expansion-panel-header>
        <mat-panel-title class="copec-rg-20">
          1. Tipo de usuario
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div id="add-user2" style="margin-bottom: 10px">
        <span class="box-description copec-lg-16">
          Ingresa aquí la información sobre el tipo de usuario
        </span>
      </div>

      <form [formGroup]="formGroup1AddUser">
        <div id="add-user3" style="display: flex; flex-direction: column; margin: 5px 0">
          <label class="copec-rg-16 mb-1" for="opciones">Tipo de usuario</label>
          <select
            id="opciones-type-user"
            class="copec-rg-14 style-input-select"
            formControlName="campo1"
          >
            <option value="">Seleccionar</option>
            <option>Jubilados</option>
          </select>
        </div>
      </form>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="step === 1">
      <mat-expansion-panel-header>
        <mat-panel-title class="copec-rg-20">
          2. Información personal
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div style="margin-bottom: 10px">
        <span class="box-description copec-lg-16">
          Ingresa aquí la información del nuevo usuario.
        </span>
      </div>
      <form id="add-user" [formGroup]="formGroup2AddUser">
        <div id="add-user-4" class="form-grid">
          <div class="form-field">
            <label class="copec-rg-16" for="nombres">Nombres</label>
            <input
              id="nombres"
              type="text"
              formControlName="nombres"
              class="style-input"
            />
            <div
              *ngIf="
                formGroup2AddUser.get('nombres')?.invalid &&
                formGroup2AddUser.get('nombres')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('nombres')?.errors?.['required']"
              >
                El campo Nombres es obligatorio.
              </small>
            </div>
          </div>

          <div id="add-user-5" class="form-field">
            <label class="copec-rg-16" for="primerApellido"
              >Primer Apellido</label
            >
            <input
              id="primerApellido"
              type="text"
              formControlName="primerApellido"
              class="style-input"
            />
            <div id="add-user-6"
              *ngIf="
                formGroup2AddUser.get('primerApellido')?.invalid &&
                formGroup2AddUser.get('primerApellido')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('primerApellido')?.errors?.['required']"
              >
                El campo Primer Apellido es obligatorio.
              </small>
            </div>
          </div>

          <div id="add-user-7" class="form-field">
            <label class="copec-rg-16" for="segundoApellido"
              >Segundo Apellido</label
            >
            <input
              id="segundoApellido"
              type="text"
              formControlName="segundoApellido"
              class="style-input"
            />
            <div id="add-user-8"
              *ngIf="
                formGroup2AddUser.get('segundoApellido')?.invalid &&
                formGroup2AddUser.get('segundoApellido')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('segundoApellido')?.errors?.['required']"
              >
                El campo Segundo Apellido es obligatorio.
              </small>
            </div>
          </div>

          <div id="add-user-9" class="form-field">
            <label class="copec-rg-16" for="rut">RUT</label>
            <input
              id="rut"
              type="text"
              formControlName="rut"
              class="style-input"
            />
            <div
              *ngIf="
                formGroup2AddUser.get('rut')?.invalid && formGroup2AddUser.get('rut')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('rut')?.errors?.['required']"
              >
                El campo RUT es obligatorio.
              </small>
            </div>
          </div>

          <div class="form-field">
            <label class="copec-rg-16" for="emailPersonal"
              >Email Personal</label
            >
            <input
              id="emailPersonal"
              type="email"
              formControlName="emailPersonal"
              class="style-input"
            />
            <div id="add-user-10"
              *ngIf="
                formGroup2AddUser.get('emailPersonal')?.invalid &&
                formGroup2AddUser.get('emailPersonal')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('emailPersonal')?.errors?.['required']"
              >
                El campo Email Personal es obligatorio.
              </small>
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('emailPersonal')?.errors?.['email']"
              >
                El formato del Email es inválido.
              </small>
            </div>
          </div>

          <div id="add-user-11" class="form-field">
            <label class="copec-rg-16" for="fechaInicio">Fecha de Inicio</label>
            <input
              id="fechaInicio"
              type="date"
              formControlName="fechaInicio"
              class="style-input"
            />
            <div id="add-user-12"
              *ngIf="
                formGroup2AddUser.get('fechaInicio')?.invalid &&
                formGroup2AddUser.get('fechaInicio')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('fechaInicio')?.errors?.['required']"
              >
                El campo Fecha de Inicio es obligatorio.
              </small>
            </div>
          </div>

          <div id="add-user-13" class="form-field">
            <label class="copec-rg-16" for="fechaFin">Fecha Fin</label>
            <input
              id="fechaFin"
              type="date"
              formControlName="fechaFin"
              class="style-input"
            />
            <div id="add-user-14"
              *ngIf="
                formGroup2AddUser.get('fechaFin')?.invalid &&
                formGroup2AddUser.get('fechaFin')?.touched
              "
            >
              <small
                class="mt-1 red"
                *ngIf="formGroup2AddUser.get('fechaFin')?.errors?.['required']"
              >
                El campo Fecha Fin es obligatorio.
              </small>
            </div>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- Botón de Guardar -->
  <div id="add-user-15" class="d-flex justify-content-end mt-3 gap-style">
    <button id="add-user-16" class="button-cancel" (click)="cancelarAddUser()">Cancelar</button>
    <button id="add-user-17"
      class="button-create"
      [disabled]="!isFormValidAddUser()"
      (click)="guardarAddUser()"
    >
      Crear usuario
    </button>
  </div>
</div>
